<template>
  <!-- <Form ref="loginForm" :model="form" :rules="rules" @keydown.enter.native="handleSubmit">
    <FormItem prop="username">
      <Input v-model="form.username" placeholder="请输入用户名"/>
    </FormItem>
    <FormItem prop="password">
      <Input type="password" v-model="form.password" password placeholder="请输入密码"/>
    </FormItem>
    <FormItem>
      <Button @click="handleSubmit" type="primary" long>登录</Button>
    </FormItem>
  </Form>-->
  <Tabs size="small" style="margin-top: -20px">
    <Tab-pane label="账号密码登录">
      <Form ref="loginForm" :model="form" :rules="rules">
        <FormItem prop="username">
          <Input v-model="form.username" placeholder="请输入用户名" />
        </FormItem>
        <FormItem prop="password">
          <Input
            type="password"
            v-model="form.password"
            password
            placeholder="请输入密码"
          />
        </FormItem>
        <FormItem>
          <Button @click="handleSubmit" type="primary" long>登录</Button>
        </FormItem>
      </Form>
    </Tab-pane>
    <Tab-pane label="手机验证码登录">
      <Form ref="loginForm" :model="form" :rules="rules">
        <FormItem prop="username2">
          <Input v-model="form.username2" placeholder="请输入用户名" />
        </FormItem>
        <FormItem prop="phone">
          <Input
            v-model="form.phone"
            placeholder="请输入手机号"
            style="width: 64%"
          />
          <i-button @click="yan" type="text">获取验证码</i-button>
        </FormItem>
        <FormItem prop="yanzheng">
          <Input v-model="form.yanzheng" placeholder="请输入验证码" />
        </FormItem>
        <FormItem>
          <Button @click="handle" type="primary" long>登录</Button>
        </FormItem>
      </Form>
    </Tab-pane>
  </Tabs>
</template>
<script>
import { sendCheckCode } from "@/api/user";
import { setToken, getToken } from "@/libs/util";
import { mapActions } from "vuex";
export default {
  name: "LoginForm",
  props: {
    userNameRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "账号不能为空", trigger: "blur" }];
      },
    },
    passwordRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "密码不能为空", trigger: "blur" }];
      },
    },
  },
  data() {
    return {
      form: {
        username: "",
        username2: "",
        password: "",
        phone: "",
        yanzheng: "",
        zheng: "",
      },
    };
  },
  computed: {
    rules() {
      return {
        username: this.usernameRules,
        password: this.passwordRules,
        phone: this.phoneRules,
      };
    },
  },
  methods: {
    ...mapActions(["handleL", "getUserInfo", "getMenuList"]),
    handleSubmit() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.$emit("on-success-valid", {
            username: this.form.username,
            password: this.form.password,
          });
        }
      });
    },
    keyDown(e) {
      //如果是回车则执行登录方法
      if (e.keyCode == 13) {
        this.handleSubmit();
      }
    },
    yan() {
      if (this.form.phone == "") {
        this.$Message.error("请输入手机号");
      } else {
        sendCheckCode({
          phone: this.form.phone,
        }).then((res) => {
          if (res.data.code == 200) {
            this.$Message.success("验证码发送成功");
            this.form.zheng = res.data.checkCode;
          } else {
            this.$Message.error("验证码发送失败");
          }
        });
      }
    },
    handle({ commit }) {
      if (!this.form.phone)
        return this.$Message.error("请输入手机号，获取验证码");
      if (!this.form.yanzheng) return this.$Message.error("请输入验证码");
      if (this.form.zheng && this.form.zheng !== this.form.yanzheng) {
        return this.$Message.error("验证码输入错误");
      }
      {
        this.handleL({
          username: this.form.username2,
          phone: this.form.phone,
          code: this.form.yanzheng,
        }).then((res) => {
          let data = res.data;
          if (data.code === 0) {
            // alert(data.user.roleList[0].roleId)
            localStorage.setItem("roleId", data.user.roleList[0].roleId);
            localStorage.setItem("clientId", data.user.clientId);
            this.getMenuList(data.token).then((rest) => {
              let date = rest.data;
              if (date.code === 401) {
                this.$router.push({
                  name: "login",
                });
              } else {
                localStorage.setItem("token", data.token);
                this.$router.push({
                  name: "home",
                });
              }
            });
          } else {
            Lacal.removeItem("token");
            this.$Message.info("登录失败：" + data.msg);
          }
        });
        // }
      }
    },
    mounted() {
      //绑定事件
      window.addEventListener("keydown", this.keyDown);
    },
    destroyed() {
      window.removeEventListener("keydown", this.keyDown, false);
    },
  },
};
</script>